import React, { useState, useEffect } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { Link, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getClinic, getPatient, getPatientsByClinicId, addAppointment, getClinicById, getAvailableSlots } from "service/api"
import { jwtDecode } from "jwt-decode"
import Select from "react-select"
import { toast } from "react-toastify"

const AddAppointment = () => {
  document.title = "Appointment | Add Appointment"
  const navigate = useNavigate()

  const [activeTab, setactiveTab] = useState(1)
  const [patientType, setPatientType] = useState("Registered")
  const [clinics, setClinics] = useState([])
  const [selectedClinic, setSelectedClinic] = useState("")
  const [clinicID, setClinicID] = useState(null) // ✅ keep track of clinic from token
  const [appointmentDate, setAppointmentDate] = useState("")
  const [clinicSchedules, setClinicSchedules] = useState([])
  const [patients, setPatients] = useState([])

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Patient Info
  const [patient, setPatient] = useState({
    mpiNo: "",
    idNumber: "",
    title: "",       // patient title (Mr, Mrs, etc.)
    gender: "",
    dob: "",
    nationality: "",
    patientName: "",
    email: "",
    contactNo: "",
    notes: "",
  })

  const [scheduleTime, setScheduleTime] = useState("")
  const [reminder, setReminder] = useState("")
  const [appointmentType, setAppointmentType] = useState("")

  // Slot picker
  const [availableSlots, setAvailableSlots] = useState([])
  const [selectedSlot, setSelectedSlot] = useState(null)
  const [slotsLoading, setSlotsLoading] = useState(false)
  const [slotMessage, setSlotMessage] = useState("")


  function toggleTab(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
  }



  useEffect(() => {
    const fetchClinics = async () => {
      try {
        const token = localStorage.getItem("token")
        let response
        if (token) {
          const decoded = jwtDecode(token)
          const id = decoded?.clinicID || null
          setClinicID(id)

          if (id) {
            response = await getClinicById(id)
            setClinics([response.data])
            setSelectedClinic(id)
          } else {
            response = await getClinic()
            setClinics(response.data)
          }
        }
      } catch (err) {
        console.error("Error fetching clinics", err)
      }
    }
    fetchClinics()
  }, [])

  // useEffect(() => {
  //   const fetchPatients = async () => {
  //     try {
  //       const token = localStorage.getItem("token")
  //       let response
  //       if (token) {
  //         const decoded = jwtDecode(token)
  //         const clinicID = decoded?.clinicID
  //         response = clinicID
  //           ? await getPatientsByClinicId(clinicID)
  //           : await getPatient()
  //         if (Array.isArray(response?.data)) {
  //           setPatients(response.data)
  //         } else if (Array.isArray(response?.data?.data)) {
  //           setPatients(response.data.data)
  //         } else {
  //           setPatients([])
  //         }
  //       }
  //     } catch (err) {
  //       console.error("Error fetching patients", err)
  //       setPatients([])
  //     }
  //   }
  //   fetchPatients()
  // }, [])

  useEffect(() => {
    const fetchPatients = async () => {
      try {
        if (!selectedClinic) {
          setPatients([])
          return
        }

        let response = await getPatientsByClinicId(selectedClinic)

        if (Array.isArray(response?.data)) {
          setPatients(response.data)
        } else if (Array.isArray(response?.data?.data)) {
          setPatients(response.data.data)
        } else {
          setPatients([])
        }
      } catch (err) {
        console.error("Error fetching patients", err)
        setPatients([])
      }
    }

    fetchPatients()
  }, [selectedClinic])



  // useEffect(() => {
  //   if (selectedClinic && appointmentDate) {
  //     const clinic = clinics.find(c => c._id === selectedClinic)
  //     if (clinic && clinic.schedule) {
  //       const filtered = clinic.schedule.filter(s => s.date === appointmentDate)
  //       setClinicSchedules(filtered)
  //     } else {
  //       setClinicSchedules([])
  //     }
  //   } else {
  //     setClinicSchedules([])
  //   }
  // }, [selectedClinic, appointmentDate, clinics])

  useEffect(() => {
    if (selectedClinic) {
      const clinic = clinics.find(c => c._id === selectedClinic)
      if (clinic && clinic.schedule) {
        setClinicSchedules(clinic.schedule)
      } else {
        setClinicSchedules([])
      }
    } else {
      setClinicSchedules([])
    }
  }, [selectedClinic, clinics])

  // Fetch available time slots when clinic + date are both set
  useEffect(() => {
    if (!selectedClinic || !appointmentDate) {
      setAvailableSlots([])
      setSelectedSlot(null)
      setScheduleTime("")
      setSlotMessage("")
      return
    }
    const fetchSlots = async () => {
      setSlotsLoading(true)
      setSelectedSlot(null)
      setScheduleTime("")
      try {
        const res = await getAvailableSlots(selectedClinic, appointmentDate)
        if (res?.data?.is_working) {
          setAvailableSlots(res.data.slots || [])
          setSlotMessage("")
        } else {
          setAvailableSlots([])
          setSlotMessage(res?.data?.message || "No schedule available for this date.")
        }
      } catch (err) {
        setAvailableSlots([])
        setSlotMessage("Could not load slots.")
      } finally {
        setSlotsLoading(false)
      }
    }
    fetchSlots()
  }, [selectedClinic, appointmentDate])



  // Disable past dates
  const today = new Date()
  today.setDate(today.getDate() - 1) // yesterday
  const minDate = new Date(today)
  minDate.setDate(minDate.getDate() + 1)
  const minDateStr = minDate.toISOString().split("T")[0]

  const handlePatientNameChange = (e) => {
    const value = e.target.value.toUpperCase();

    // allow only letters and spaces
    if (/^[a-zA-Z\s]*$/.test(value)) {
      setPatient({ ...patient, patientName: value });
      setErrors(prev => ({ ...prev, patientName: "" }));
    }
  };


  const handleMpiChange = (selectedOption) => {
    const selectedPatient = patients.find(p => p.mpino === selectedOption.value)
    if (selectedPatient) {
      setPatient({
        ...patient,
        mpiNo: selectedPatient.mpino,
        gender: selectedPatient.gender || "",
        dob: selectedPatient.dob || "",
        patientName: `${selectedPatient.firstname || ""} ${selectedPatient.lastname || ""}`,
        email: selectedPatient.email || "",
        contactNo: selectedPatient.mobile || "",
      })
      // ✅ clear all related errors
      setErrors(prev => ({
        ...prev,
        mpiNo: "",
        gender: "",
        dob: "",
        patientName: "",
        email: "",
        contactNo: ""
      }))
    }
  }


  const handlePatientTypeChange = (e) => {
    const type = e.target.value
    setPatientType(type)
    if (type === "Registered") {
      setPatient({ ...patient, idNumber: "", nationality: "" })
    } else {
      setPatient({ ...patient, mpiNo: "", nationality: "South African" })
    }
    setErrors(prev => ({ ...prev, patientType: "" }))
  }

  const handleNationalityChange = (e) => {
    setPatient({ ...patient, nationality: e.target.value })
    setErrors(prev => ({ ...prev, nationality: "" }))
  }

  const handleContactNoChange = (e) => {
    const value = e.target.value;

    // allow only digits
    if (/^\d*$/.test(value)) {
      setPatient({ ...patient, contactNo: value });
      setErrors(prev => ({ ...prev, contactNo: "" }));
    }
  };


  const validate = () => {
    const newErrors = {}

    if (!selectedClinic) newErrors.selectedClinic = "Practice  is required"

    if (!patientType) newErrors.patientType = "Patient Type is required"

    if (patientType === "Registered") {
      if (!patient.mpiNo) newErrors.mpiNo = "MPI No is required"
    } else if (patientType === "Unregistered") {
      if (!patient.idNumber) newErrors.idNumber = "ID Number is required"
      if (!patient.nationality) newErrors.nationality = "Nationality is required"
    }

    if (!patient.gender) newErrors.gender = "Gender is required"
    if (!patient.dob) newErrors.dob = "DOB is required"
    if (!patient.patientName) newErrors.patientName = "Patient Name is required"
    // if (!patient.email) newErrors.email = "Email is required"
    if (!patient.contactNo) newErrors.contactNo = "Contact No is required"

    if (!appointmentDate) newErrors.appointmentDate = "Appointment Date is required"
    if (!scheduleTime) newErrors.scheduleTime = "Schedule time is required"

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }


  const handleBookAppointment = async () => {
    if (!validate()) return

    try {
      setLoading(true)

      const payload = {
        clinic_wkh_id: null,
        clinic_name: clinics.find(c => c._id === selectedClinic)?.name || "",
        apnt_clinicid: selectedClinic,
        appointment_date: appointmentDate,
        appointment_time: scheduleTime,
        apnt_start_time: selectedSlot?.start_time || "",
        apnt_end_time: selectedSlot?.end_time || "",
        apnt_type: appointmentType,
        apnt_reminder: reminder,
        patient_mpi: patientType === "Registered" ? patient.mpiNo : null,
        patient_idno: patientType === "Unregistered" ? patient.idNumber : null,
        patient_dob: patient.dob,
        app_nationality: patientType === "Unregistered" ? patient.nationality : null,
        patient_title: patient.title,
        patient_name: patient.patientName,
        gender: patient.gender,
        email: patient.email,
        mobileno: patient.contactNo,
        notes: patient.notes,
        appointment_status: "Approved",
      }

      const res = await addAppointment(payload)

      if (res?.data) {
        toast.success("Appointment booked successfully!", { position: "top-center", autoClose: 1500 })
        setTimeout(() => navigate("/AppointmentList"), 1600)
      }
    } catch (err) {
      console.error("Error booking appointment:", err)
      toast.error("Failed to book appointment", { position: "top-center", autoClose: 2000 })
    } finally {
      setLoading(false)
    }
  }

  const activeErrors = Object.keys(errors).filter(
    (key) => errors[key] && errors[key].trim() !== ""
  );



  const formatTime12 = (t) => {
    if (!t) return ""
    const [h, m] = t.split(":").map(Number)
    const ampm = h >= 12 ? "PM" : "AM"
    const hour = h % 12 || 12
    return `${String(hour).padStart(2, "0")}:${String(m).padStart(2, "0")} ${ampm}`
  }

  const groupedSlots = () => {
    const morning = [], afternoon = [], evening = []
    availableSlots.forEach(s => {
      const h = parseInt(s.start_time.split(":")[0])
      if (h < 12) morning.push(s)
      else if (h < 17) afternoon.push(s)
      else evening.push(s)
    })
    return { morning, afternoon, evening }
  }

  const cardTopStyle = {
    backgroundColor: "#DC4C64",
    padding: "4px",
    color: "white",
    height: "30px",
    borderRadius: "4px",
    fontWeight: "bold",
  }
  const validateIdNumber = (idNumber) => {
    if (!idNumber) {
      setPatient(prev => ({ ...prev, dob: "", gender: "" }));
      return;
    }

    if (idNumber.length === 13) {
      const year = parseInt(idNumber.substring(0, 2), 10);
      const month = parseInt(idNumber.substring(2, 4), 10) - 1;
      const day = parseInt(idNumber.substring(4, 6), 10);

      const fullYear = year > 23 ? 1900 + year : 2000 + year;

      const date = new Date(Date.UTC(fullYear, month, day));

      if (
        date.getUTCFullYear() === fullYear &&
        date.getUTCMonth() === month &&
        date.getUTCDate() === day
      ) {
        const formattedDate = `${date.getUTCFullYear()}-${String(
          month + 1
        ).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

        const genderCode = parseInt(idNumber.substring(6, 10), 10);
        const gender = genderCode < 5000 ? "Female" : "Male";

        setPatient(prev => ({
          ...prev,
          dob: formattedDate,
          gender: gender,
        }));

        setErrors(prev => ({ ...prev, idNumber: "" }));
      } else {
        setPatient(prev => ({ ...prev, dob: "", gender: "" }));
        setErrors(prev => ({ ...prev, idNumber: "Invalid ID Number" }));
      }
    } else {
      setPatient(prev => ({ ...prev, dob: "", gender: "" }));
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          {/* <Breadcrumbs title="Appointment" breadcrumbItem="Add Appointment" /> */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            {/* <CardTitle className="mb-4">ADD Patient</CardTitle> */}
            <h4 className="page-title">ADD Appointment</h4>
            <Link to="/AppointmentList" className="btn btn-danger">
              Appointment List
            </Link>
          </div>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* <h4 className="card-title mb-4">Add Appointment</h4> */}
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem className={classnames({ current: activeTab === 1 })}>
                          <NavLink onClick={() => toggleTab(1)}>
                            <span className="number">1.</span> Patient Details
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 2 })}>
                          <NavLink onClick={() => toggleTab(2)}>
                            <span className="number">2.</span> Schedule Details
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 3 })}>
                          <NavLink onClick={() => toggleTab(3)}>
                            <span className="number">3.</span> Review Your Details
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>

                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                        {/* STEP 1 */}
                        <TabPane tabId={1}>
                          <Form>
                            <Row>
                              {/* Patient Type */}
                              <Col lg="3" className="mb-3">
                                <Label>Patient Type <span className="text-danger">*</span></Label>
                                <div style={{ display: "inline-flex", borderRadius: "6px", overflow: "hidden", border: "1px solid #f46a6a", width: "fit-content" }}>
                                  {["Registered", "Unregistered"].map((type) => (
                                    <button
                                      key={type}
                                      type="button"
                                      onClick={() => handlePatientTypeChange({ target: { value: type } })}
                                      style={{
                                        padding: "3px 12px",
                                        fontSize: "11px",
                                        fontWeight: "600",
                                        border: "none",
                                        borderRight: type === "Registered" ? "1px solid #f46a6a" : "none",
                                        background: patientType === type ? "#f46a6a" : "#fff",
                                        color: patientType === type ? "#fff" : "#f46a6a",
                                        cursor: "pointer",
                                        transition: "all 0.15s",
                                      }}
                                    >
                                      {type}
                                    </button>
                                  ))}
                                </div>
                                {errors.patientType && <div className="text-danger" style={{ fontSize: "11px", marginTop: "4px" }}>{errors.patientType}</div>}
                              </Col>

                              {/* <Col lg="3" className="mb-3">
                                <Label>Practice <span className="text-danger">*</span></Label>
                                <Input
                                  type="select"
                                  value={selectedClinic}
                                  onChange={(e) => {
                                    setSelectedClinic(e.target.value)
                                    setErrors(prev => ({ ...prev, selectedClinic: "" }))
                                  }}
                                  disabled={!!clinicID}>
                                  {!clinicID && <option value="">Select</option>}
                                  {clinics.map(clinic => <option key={clinic._id} value={clinic._id}>{clinic.name}</option>)}
                                </Input>
                                {errors.selectedClinic && <div className="text-danger">{errors.selectedClinic}</div>}
                              </Col> */}

                              <Col lg="3" className="mb-3">
                                <Label>Practice <span className="text-danger">*</span></Label>
                                <Input
                                  type="select"
                                  value={selectedClinic}
                                  onChange={(e) => {
                                    const newClinic = e.target.value
                                    setSelectedClinic(newClinic)
                                    setPatient((prev) => ({ ...prev, mpiNo: "" }))
                                    setPatients([])
                                    setAvailableSlots([])
                                    setSelectedSlot(null)
                                    setScheduleTime("")
                                    setErrors(prev => ({ ...prev, selectedClinic: "" }))
                                  }}
                                  disabled={!!clinicID}
                                >
                                  {!clinicID && <option value="">Select</option>}
                                  {clinics.map(clinic => (
                                    <option key={clinic._id} value={clinic._id}>
                                      {clinic.name}
                                    </option>
                                  ))}
                                </Input>
                                {errors.selectedClinic && <div className="text-danger">{errors.selectedClinic}</div>}
                              </Col>


                              {patientType === "Registered" ? (
                                <Col lg="3" className="mb-3">
                                  <Label>Select MPI No <span className="text-danger">*</span></Label>
                                  <Select
                                    value={patient.mpiNo ? { label: patient.mpiNo, value: patient.mpiNo } : null}
                                    options={patients.map((p) => ({
                                      value: p.mpino,
                                      label: p.mpino,
                                    }))}
                                    onChange={handleMpiChange}
                                  />
                                  {errors.mpiNo && <div className="text-danger">{errors.mpiNo}</div>}
                                </Col>
                              ) : (
                                <Col lg="3" className="mb-3">
                                  <Label>ID Number <span className="text-danger">*</span></Label>
                                  <Input
                                    type="text"
                                    value={patient.idNumber}
                                    maxLength={13}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      // Allow only digits
                                      if (/^\d*$/.test(value)) {
                                        setPatient({ ...patient, idNumber: value });
                                        setErrors((prev) => ({ ...prev, idNumber: "" }));

                                        validateIdNumber(value);   // 👈 Auto trigger validation
                                      }
                                    }}
                                  />
                                  {/* <Input
                                    type="text"
                                    value={patient.idNumber}
                                    maxLength={13}
                                    onChange={(e) => {
                                      setPatient({ ...patient, idNumber: e.target.value })
                                      setErrors((prev) => ({ ...prev, idNumber: "" }))
                                    }}
                                  /> */}
                                  {errors.idNumber && <div className="text-danger">{errors.idNumber}</div>}
                                </Col>
                              )}


                              {/* <Col lg="3" className="mb-3">
                                <Label>Gender <span className="text-danger">*</span></Label>
                                <Input
                                  type="text"
                                  value={patient.gender}
                                  onChange={(e) => {
                                    setPatient({ ...patient, gender: e.target.value })
                                    setErrors(prev => ({ ...prev, gender: "" }))
                                  }}
                                />
                                {errors.gender && <div className="text-danger">{errors.gender}</div>}
                              </Col> */}
                              <Col lg="3" className="mb-3">
                                <Label>
                                  Gender <span className="text-danger">*</span>
                                </Label>

                                <Input
                                  type="select"
                                  value={patient.gender || ""}
                                  onChange={(e) => {
                                    setPatient({ ...patient, gender: e.target.value });
                                    setErrors(prev => ({ ...prev, gender: "" }));
                                  }}
                                >
                                  <option value="">-- Select Gender --</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                  <option value="Other">Other</option>
                                </Input>

                                {errors.gender && (
                                  <div className="text-danger">{errors.gender}</div>
                                )}
                              </Col>
                              <Col lg="3" className="mb-3">
                                <Label>Date of Birth <span className="text-danger">*</span></Label>
                                <Input
                                  type="date"
                                  value={patient.dob}
                                  onChange={(e) => {
                                    setPatient({ ...patient, dob: e.target.value })
                                    setErrors(prev => ({ ...prev, dob: "" }))
                                  }}
                                />
                                {errors.dob && <div className="text-danger">{errors.dob}</div>}
                              </Col>

                              {patientType === "Unregistered" && (
                                <Col lg="3" className="mb-3">
                                  <Label>Nationality <span className="text-danger">*</span></Label>
                                  <div style={{ display: "inline-flex", borderRadius: "6px", overflow: "hidden", border: "1px solid #f46a6a", width: "fit-content" }}>
                                    {["South African", "Non-South African"].map((nat) => (
                                      <button
                                        key={nat}
                                        type="button"
                                        onClick={() => handleNationalityChange({ target: { value: nat } })}
                                        style={{
                                          padding: "3px 12px",
                                          fontSize: "11px",
                                          fontWeight: "600",
                                          border: "none",
                                          borderRight: nat === "South African" ? "1px solid #f46a6a" : "none",
                                          background: patient.nationality === nat ? "#f46a6a" : "#fff",
                                          color: patient.nationality === nat ? "#fff" : "#f46a6a",
                                          cursor: "pointer",
                                          transition: "all 0.15s",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {nat}
                                      </button>
                                    ))}
                                  </div>
                                  {errors.nationality && <div className="text-danger" style={{ fontSize: "11px", marginTop: "4px" }}>{errors.nationality}</div>}
                                </Col>
                              )}
                              {patientType === "Unregistered" && (
                                <Col md={1}>
                                  <div className="mb-3">
                                    <Label htmlFor="formrow-country-Input">
                                      Title
                                    </Label>
                                    <select
                                      name="mmtitle"
                                      className="form-control"
                                      value={patient.title}
                                      onChange={(e) =>
                                        setPatient({ ...patient, title: e.target.value })
                                      }
                                    >
                                      <option value="">Select</option>
                                      <option value="Mr">Mr</option>
                                      <option value="Ms">Ms</option>
                                      <option value="Mrs">Mrs</option>
                                      <option value="Dr">Dr</option>
                                      <option value="Prof">Prof</option>
                                    </select>
                                  </div>
                                </Col>
                              )}


                              <Col lg="3" className="mb-3">
                                <Label>
                                  Patient Name <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="text"
                                  value={patient.patientName}
                                  onChange={handlePatientNameChange}
                                  placeholder="Enter patient name"
                                />
                                {errors.patientName && (
                                  <div className="text-danger">{errors.patientName}</div>
                                )}
                              </Col>

                              <Col lg="2" className="mb-3">
                                <Label>
                                  Contact No <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="text"
                                  value={patient.contactNo}
                                  maxLength={11}
                                  onChange={handleContactNoChange}
                                  placeholder="Enter contact number"
                                />
                                {errors.contactNo && (
                                  <div className="text-danger">{errors.contactNo}</div>
                                )}
                              </Col>

                              <Col lg="3" className="mb-3">
                                <Label>Email</Label>
                                <Input
                                  type="email"
                                  value={patient.email}
                                  onChange={(e) => {
                                    setPatient({ ...patient, email: e.target.value })
                                    setErrors(prev => ({ ...prev, email: "" }))
                                  }}
                                />
                                {errors.email && <div className="text-danger">{errors.email}</div>}
                              </Col>



                              <Col lg="3" className="mb-3">
                                <Label>Notes</Label>
                                <Input
                                  type="textarea"
                                  value={patient.notes}
                                  onChange={(e) =>
                                    setPatient({ ...patient, notes: e.target.value })
                                  }
                                />
                              </Col>
                            </Row>
                          </Form>
                        </TabPane>

                        {/* STEP 2 */}
                        <TabPane tabId={2}>
                          <div style={{ display: "flex", border: "1px solid #f0e8e8", borderRadius: "12px", overflow: "hidden", minHeight: "420px" }}>

                            {/* ── LEFT PANEL ── */}
                            <div style={{ width: "340px", flexShrink: 0, background: "linear-gradient(160deg,#fff5f5 0%,#fafafa 100%)", borderRight: "1px solid #f0e8e8", padding: "22px 20px", display: "flex", flexDirection: "column", gap: "0" }}>

                              {/* Panel header */}
                              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "18px" }}>
                                <div style={{ width: "30px", height: "30px", borderRadius: "8px", background: "#f46a6a", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <i className="mdi mdi-calendar-edit" style={{ color: "#fff", fontSize: "15px" }} />
                                </div>
                                <div>
                                  <div style={{ fontSize: "12px", fontWeight: "700", color: "#333" }}>Appointment Details</div>
                                  <div style={{ fontSize: "10px", color: "#aaa" }}>Fill in date and preferences</div>
                                </div>
                              </div>

                              {/* Date */}
                              <div className="mb-3">
                                <label style={{ fontSize: "11px", fontWeight: "700", color: "#555", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: "5px", display: "block" }}>
                                  <i className="mdi mdi-calendar me-1 text-danger" />Appointment Date <span style={{ color: "#dc3545" }}>*</span>
                                </label>
                                <Input
                                  type="date"
                                  min={minDateStr}
                                  value={appointmentDate}
                                  onChange={(e) => {
                                    setAppointmentDate(e.target.value)
                                    setErrors(prev => ({ ...prev, appointmentDate: "" }))
                                  }}
                                  style={{ fontSize: "13px", borderColor: errors.appointmentDate ? "#dc3545" : "#e8d8d8", borderRadius: "8px" }}
                                />
                                {errors.appointmentDate && <div style={{ fontSize: "11px", color: "#dc3545", marginTop: "3px" }}>{errors.appointmentDate}</div>}
                              </div>

                              {/* Reminder */}
                              <div className="mb-3">
                                <label style={{ fontSize: "11px", fontWeight: "700", color: "#555", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: "5px", display: "block" }}>
                                  <i className="mdi mdi-bell-outline me-1 text-danger" />Reminder
                                </label>
                                <Input
                                  type="select"
                                  value={reminder}
                                  onChange={(e) => setReminder(e.target.value)}
                                  style={{ fontSize: "13px", borderColor: "#e8d8d8", borderRadius: "8px" }}
                                >
                                  <option value="">None</option>
                                  <option>1 Day</option>
                                  <option>3 Days</option>
                                  <option>1 Week</option>
                                </Input>
                              </div>

                              {/* Appointment Type */}
                              <div className="mb-3">
                                <label style={{ fontSize: "11px", fontWeight: "700", color: "#555", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: "5px", display: "block" }}>
                                  <i className="mdi mdi-tag-outline me-1 text-danger" />Appointment Type
                                </label>
                                <Input
                                  type="select"
                                  value={appointmentType}
                                  onChange={(e) => setAppointmentType(e.target.value)}
                                  style={{ fontSize: "13px", borderColor: "#e8d8d8", borderRadius: "8px" }}
                                >
                                  <option value="">Select type</option>
                                  <option>Follow-up</option>
                                  <option>New Visit</option>
                                </Input>
                              </div>

                              {/* Summary card */}
                              <div style={{ marginTop: "auto", background: "#fff", border: "1px solid #f5dede", borderRadius: "10px", padding: "14px", boxShadow: "0 2px 8px rgba(244,106,106,0.07)" }}>
                                <div style={{ fontSize: "10px", fontWeight: "700", color: "#f46a6a", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px" }}>
                                  Summary
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                  <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                                    <i className="mdi mdi-calendar-check" style={{ color: "#f46a6a", fontSize: "14px", marginTop: "1px" }} />
                                    <div>
                                      <div style={{ fontSize: "9px", color: "#aaa", textTransform: "uppercase" }}>Date</div>
                                      <div style={{ fontSize: "12px", fontWeight: "600", color: "#333" }}>
                                        {appointmentDate
                                          ? new Date(appointmentDate + "T00:00:00").toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "long", year: "numeric" })
                                          : <span style={{ color: "#ccc" }}>Not selected</span>}
                                      </div>
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                                    <i className="mdi mdi-clock-outline" style={{ color: "#f46a6a", fontSize: "14px", marginTop: "1px" }} />
                                    <div>
                                      <div style={{ fontSize: "9px", color: "#aaa", textTransform: "uppercase" }}>Time Slot</div>
                                      <div style={{ fontSize: "12px", fontWeight: "600", color: selectedSlot ? "#f46a6a" : "#ccc" }}>
                                        {selectedSlot ? `${formatTime12(selectedSlot.start_time)} – ${formatTime12(selectedSlot.end_time)}` : "Not selected"}
                                      </div>
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                                    <i className="mdi mdi-stethoscope" style={{ color: "#f46a6a", fontSize: "14px", marginTop: "1px" }} />
                                    <div>
                                      <div style={{ fontSize: "9px", color: "#aaa", textTransform: "uppercase" }}>Type</div>
                                      <div style={{ fontSize: "12px", fontWeight: "600", color: appointmentType ? "#333" : "#ccc" }}>
                                        {appointmentType || "Not selected"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>

                            {/* ── RIGHT PANEL ── */}
                            <div style={{ flex: 1, padding: "22px 20px", background: "#fff", overflowY: "auto", maxHeight: "520px" }}>

                              {/* Panel header */}
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "14px" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <div style={{ width: "30px", height: "30px", borderRadius: "8px", background: "#fff5f5", border: "1.5px solid #f46a6a", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <i className="mdi mdi-clock-time-four-outline" style={{ color: "#f46a6a", fontSize: "15px" }} />
                                  </div>
                                  <div>
                                    <div style={{ fontSize: "12px", fontWeight: "700", color: "#333" }}>Available Time Slots</div>
                                    <div style={{ fontSize: "10px", color: "#aaa" }}>
                                      {appointmentDate
                                        ? new Date(appointmentDate + "T00:00:00").toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "short" })
                                        : "Select a date to view slots"}
                                    </div>
                                  </div>
                                </div>
                                {availableSlots.length > 0 && (
                                  <div style={{ display: "flex", gap: "8px", fontSize: "10px" }}>
                                    <span style={{ padding: "2px 8px", background: "#e8f5e9", color: "#2e7d32", borderRadius: "10px", fontWeight: "600" }}>
                                      {availableSlots.filter(s => s.available > 0).length} open
                                    </span>
                                    <span style={{ padding: "2px 8px", background: "#fbe9e7", color: "#bf360c", borderRadius: "10px", fontWeight: "600" }}>
                                      {availableSlots.filter(s => s.available <= 0).length} full
                                    </span>
                                  </div>
                                )}
                              </div>

                              {/* Loading */}
                              {slotsLoading && (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "280px", color: "#aaa" }}>
                                  <span className="spinner-border text-danger" style={{ width: "32px", height: "32px" }} />
                                  <div style={{ marginTop: "12px", fontSize: "13px" }}>Loading available slots...</div>
                                </div>
                              )}

                              {/* Hint */}
                              {!slotsLoading && (!selectedClinic || !appointmentDate) && (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "280px", color: "#ccc", textAlign: "center" }}>
                                  <i className="mdi mdi-calendar-search" style={{ fontSize: "48px", marginBottom: "10px" }} />
                                  <div style={{ fontSize: "13px", fontWeight: "600", color: "#bbb" }}>
                                    {!selectedClinic ? "Select a practice in Step 1" : "Pick an appointment date on the left"}
                                  </div>
                                  <div style={{ fontSize: "11px", color: "#ddd", marginTop: "4px" }}>Available slots will appear here</div>
                                </div>
                              )}

                              {/* No schedule */}
                              {!slotsLoading && slotMessage && (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "280px", textAlign: "center" }}>
                                  <i className="mdi mdi-calendar-remove" style={{ fontSize: "40px", color: "#ffc107", marginBottom: "10px" }} />
                                  <div style={{ fontSize: "13px", fontWeight: "600", color: "#856404" }}>{slotMessage}</div>
                                  <div style={{ fontSize: "11px", color: "#aaa", marginTop: "4px" }}>Try a different date or contact the practice.</div>
                                </div>
                              )}

                              {/* Slot grid */}
                              {!slotsLoading && availableSlots.length > 0 && (() => {
                                const THEME = "#f46a6a"
                                const { morning, afternoon, evening } = groupedSlots()

                                const renderGroup = (label, icon, color, slots) => {
                                  if (slots.length === 0) return null
                                  return (
                                    <div style={{ marginBottom: "16px" }}>
                                      <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "8px" }}>
                                        <div style={{ width: "22px", height: "22px", borderRadius: "6px", background: color + "20", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                          <i className={`mdi ${icon}`} style={{ color, fontSize: "13px" }} />
                                        </div>
                                        <span style={{ fontSize: "11px", fontWeight: "700", color: "#555", textTransform: "uppercase", letterSpacing: "0.5px" }}>{label}</span>
                                        <span style={{ fontSize: "10px", color: "#bbb" }}>({slots.filter(s => s.available > 0).length} available)</span>
                                        <span style={{ flex: 1, height: "1px", background: "#f5f5f5" }} />
                                      </div>
                                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))", gap: "6px" }}>
                                        {slots.map(slot => {
                                          const isFull = slot.available <= 0
                                          const isFew = !isFull && slot.available <= 2
                                          const isSelected = selectedSlot?.start_time === slot.start_time
                                          return (
                                            <button
                                              key={slot.start_time}
                                              type="button"
                                              disabled={isFull}
                                              onClick={() => {
                                                setSelectedSlot(slot)
                                                setScheduleTime(`${slot.start_time} - ${slot.end_time}`)
                                                setErrors(prev => ({ ...prev, scheduleTime: "" }))
                                              }}
                                              style={{
                                                padding: "8px 10px",
                                                border: `1.5px solid ${isSelected ? THEME : isFull ? "#ececec" : isFew ? "#ffe0b2" : "#e8f5e9"}`,
                                                borderRadius: "10px",
                                                background: isSelected ? THEME : isFull ? "#fafafa" : "#fff",
                                                color: isSelected ? "#fff" : isFull ? "#c5c5c5" : "#333",
                                                cursor: isFull ? "not-allowed" : "pointer",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                gap: "2px",
                                                transition: "all 0.15s",
                                                boxShadow: isSelected ? `0 3px 10px rgba(244,106,106,0.35)` : isFull ? "none" : "0 1px 4px rgba(0,0,0,0.04)",
                                                opacity: isFull ? 0.5 : 1,
                                                position: "relative",
                                              }}
                                            >
                                              {isSelected && (
                                                <span style={{ position: "absolute", top: "5px", right: "6px", fontSize: "10px" }}>✓</span>
                                              )}
                                              <span style={{ fontSize: "12px", fontWeight: "700", letterSpacing: "0.2px" }}>
                                                {formatTime12(slot.start_time)}
                                              </span>
                                              <span style={{ fontSize: "10px", opacity: 0.7 }}>
                                                – {formatTime12(slot.end_time)}
                                              </span>
                                              <span style={{
                                                marginTop: "4px",
                                                fontSize: "9px", fontWeight: "700",
                                                padding: "1px 6px", borderRadius: "8px",
                                                background: isSelected ? "rgba(255,255,255,0.2)" : isFull ? "#ececec" : isFew ? "#fff3e0" : "#e8f5e9",
                                                color: isSelected ? "#fff" : isFull ? "#bbb" : isFew ? "#e65100" : "#2e7d32",
                                              }}>
                                                {isFull ? "Full" : `${slot.available} open`}
                                              </span>
                                            </button>
                                          )
                                        })}
                                      </div>
                                    </div>
                                  )
                                }

                                return (
                                  <>
                                    {errors.scheduleTime && (
                                      <div style={{ fontSize: "11px", color: "#dc3545", marginBottom: "10px", display: "flex", alignItems: "center", gap: "5px" }}>
                                        <i className="mdi mdi-alert-circle-outline" />
                                        {errors.scheduleTime}
                                      </div>
                                    )}
                                    {renderGroup("Morning", "mdi-weather-sunny", "#f59e0b", morning)}
                                    {renderGroup("Afternoon", "mdi-weather-partly-cloudy", "#3b82f6", afternoon)}
                                    {renderGroup("Evening", "mdi-weather-night", "#8b5cf6", evening)}
                                    {/* Legend */}
                                    <div style={{ display: "flex", gap: "14px", paddingTop: "10px", borderTop: "1px solid #f5f5f5", fontSize: "10px", color: "#aaa", marginTop: "4px" }}>
                                      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <span style={{ width: "8px", height: "8px", borderRadius: "2px", background: "#e8f5e9", border: "1px solid #c8e6c9", display: "inline-block" }} />Available
                                      </span>
                                      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <span style={{ width: "8px", height: "8px", borderRadius: "2px", background: "#fff3e0", border: "1px solid #ffe0b2", display: "inline-block" }} />Few left
                                      </span>
                                      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <span style={{ width: "8px", height: "8px", borderRadius: "2px", background: "#fafafa", border: "1px solid #ececec", display: "inline-block" }} />Full
                                      </span>
                                      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <span style={{ width: "8px", height: "8px", borderRadius: "2px", background: "#f46a6a", display: "inline-block" }} />Selected
                                      </span>
                                    </div>
                                  </>
                                )
                              })()}

                            </div>
                          </div>
                        </TabPane>

                        {/* STEP 3 */}
                        <TabPane tabId={3}>
                          <div className="row">
                            <div className="col-lg-2 col-md-6 mb-2">
                              <label className="form-label">Patient Name</label>
                              <div className="form-control-plaintext">{patient.patientName}</div>
                            </div>

                            <div className="col-lg-2 col-md-6 mb-2">
                              <label className="form-label">Patient Type</label>
                              <div className="form-control-plaintext">{patientType}</div>
                            </div>

                            {patientType === "Registered" && (
                              <div className="col-lg-2 col-md-6 mb-2">
                                <label className="form-label">MPI Number</label>
                                <div className="form-control-plaintext">{patient.mpiNo}</div>
                              </div>
                            )}

                            {patientType === "Unregistered" && (
                              <>
                                <div className="col-lg-2 col-md-6 mb-2">
                                  <label className="form-label">Nationality</label>
                                  <div className="form-control-plaintext">{patient.nationality}</div>
                                </div>
                                <div className="col-lg-2 col-md-6 mb-2">
                                  <label className="form-label">ID Number</label>
                                  <div className="form-control-plaintext">{patient.idNumber}</div>
                                </div>
                              </>
                            )}

                            <div className="col-lg-2 col-md-6 mb-2">
                              <label className="form-label">Gender</label>
                              <div className="form-control-plaintext">{patient.gender}</div>
                            </div>

                            <div className="col-lg-2 col-md-6 mb-2">
                              <label className="form-label">Date of Birth</label>
                              <div className="form-control-plaintext">{patient.dob}</div>
                            </div>

                            <div className="col-lg-2 col-md-6 mb-2">
                              <label className="form-label">Contact No</label>
                              <div className="form-control-plaintext">{patient.contactNo}</div>
                            </div>

                            <div className="col-lg-2 col-md-6 mb-2">
                              <label className="form-label">Email</label>
                              <div className="form-control-plaintext">{patient.email}</div>
                            </div>

                            <div className="col-lg-2 col-md-6 mb-2">
                              <label className="form-label">Appointment Date</label>
                              <div className="form-control-plaintext">{appointmentDate}</div>
                            </div>

                            <div className="col-lg-2 col-md-6 mb-2">
                              <label className="form-label">Appointment Time</label>
                              <div className="form-control-plaintext">{scheduleTime}</div>
                            </div>

                            <div className="col-lg-2 col-md-6 mb-2">
                              <label className="form-label">Appointment Type</label>
                              <div className="form-control-plaintext">{appointmentType}</div>
                            </div>

                            <div className="col-lg-2 col-md-6 mb-2">
                              <label className="form-label">Reminder</label>
                              <div className="form-control-plaintext">{reminder}</div>
                            </div>

                            <div className="col-lg-4 col-md-12 mb-2">
                              <label className="form-label">Notes</label>
                              <div className="form-control-plaintext">{patient.notes}</div>
                            </div>
                          </div>

                          {activeErrors.length > 0 && (
                            <div className="alert alert-danger mt-3">
                              <p>Please fill the required data:</p>
                              <ul>
                                {errors.patientType && <li>{errors.patientType}</li>}
                                {errors.selectedClinic && <li>{errors.selectedClinic}</li>}
                                {errors.mpiNo && <li>{errors.mpiNo}</li>}
                                {errors.idNumber && <li>{errors.idNumber}</li>}
                                {errors.nationality && <li>{errors.nationality}</li>}
                                {errors.gender && <li>{errors.gender}</li>}
                                {errors.dob && <li>{errors.dob}</li>}
                                {errors.patientName && <li>{errors.patientName}</li>}
                                {errors.email && <li>{errors.email}</li>}
                                {errors.contactNo && <li>{errors.contactNo}</li>}
                                {errors.appointmentDate && <li>{errors.appointmentDate}</li>}
                                {errors.scheduleTime && <li>{errors.scheduleTime}</li>}
                              </ul>
                            </div>
                          )}
                        </TabPane>
                      </TabContent>
                    </div>

                    <div className="actions clearfix">
                      <ul>
                        <li className={activeTab === 1 ? "previous disabled" : "previous"}>
                          <Link to="#" onClick={() => toggleTab(activeTab - 1)}>Previous</Link>
                        </li>
                        <li className={activeTab === 3 ? "next disabled" : "next"}>
                          {activeTab === 3 ? (
                            <button type="button" className="btn btn-primary" onClick={handleBookAppointment} disabled={loading}>
                              {loading ? "Booking..." : "Book Appointment"}
                            </button>
                          ) : (
                            <Link to="#" onClick={() => toggleTab(activeTab + 1)}>Next</Link>
                          )}
                        </li>
                      </ul>
                    </div>

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddAppointment
